import { AccessRestricted } from './features/error-pages/access-restricted/access-restricted';
import { NotFound } from './features/error-pages/not-found/not-found';
import { SomethingWentWrong } from './features/error-pages/something-went-wrong/something-went-wrong';
import { Route } from './models';
import { authGuard } from './router/auth-guard';
import { requestDetailsGuard } from './router/request-details-guard';
import { selfAssessmentGuard } from './router/self-assessment-guard';
import { systemLogsGuard } from './router/system-logs-guard';
import { systemSettingsGuardGuard } from './router/system-settings-guard-guard';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'requests',
    pathMatch: 'full',
  },
  {
    path: 'home',
    title: 'home.title',
    data: {
      isolatePageContent: true,
    },
    loadComponent: () =>
      import('./features/home-page/home-page').then((m) => m.HomePage),
  },
  {
    path: 'facilities',
    title: 'facilities.tableTitle',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/facilities/facilities').then((m) => m.Facilities),
  },
  {
    path: 'requests',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        title: 'certificationRequests.title',
        loadComponent: () =>
          import('./features/certification-request/requests/requests').then(
            (m) => m.Requests,
          ),
      },
      {
        path: `self-assessment/:requestId`,
        canActivate: [selfAssessmentGuard],
        title: 'selfAssessment.title',
        loadComponent: () =>
          import('./features/certification-request/self-assessment/self-assessment').then(
            (m) => m.SelfAssessment,
          ),
      },
      {
        path: `details/:requestId`,
        title: 'requestDetails.title',
        canActivate: [requestDetailsGuard],
        loadComponent: () =>
          import('./features/certification-request/request-details/request-details').then(
            (m) => m.RequestDetails,
          ),
      },
    ],
  },
  {
    path: 'settings',
    title: 'settings.title',
    canActivate: [authGuard, systemSettingsGuardGuard],
    loadComponent: () =>
      import('./features/settings/settings').then((m) => m.Settings),
  },
  {
    path: 'system-logs',
    title: 'systemLogs.pageTitle',
    canActivate: [authGuard, systemLogsGuard],
    loadComponent: () =>
      import('./features/system-logs/system-logs').then((m) => m.SystemLogs),
  },
  {
    path: 'not-found',
    title: 'errorPages.notFound.title',
    component: NotFound,
  },
  {
    path: 'access-restricted',
    title: 'errorPages.accessRestricted.title',
    component: AccessRestricted,
  },
  {
    path: 'something-went-wrong',
    title: 'errorPages.somethingWentWrong.title',
    component: SomethingWentWrong,
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
